import React from 'react';
import { connect } from 'react-redux';
import { openDrawer } from '../../components/general/NavigationDrawer';

function SignedInLinks(props) {

  return (
    <ul className="right">
      <li>
        <button onClick={() => openDrawer()} className="sidenav-always btn-menu">
          <i className="material-icons">menu</i>
        </button>
      </li>
    </ul>
  );
}

export default connect(null)(SignedInLinks);
